import React, { useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { toggleModal } from './store/modal/index.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import { getCookie, setCookie } from './utils/cookies.js';
import { j as COOKIE_STOP_REDIRECT, a as COOKIE_LANGUAGE_NAME, m as COOKIE_LANG_PREF } from './cookies-VX_DpI1q.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-dEXHnASi.js';
import { H as HOME } from './paths-ZKN3m62_.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-WYINLSKJ.js';
import { c as XXXL_WIDTH } from './breakpoints-X1SKRYyW.js';
import './currency-_kacFJHO.js';
import { b as LANGUAGE_OPTIONS } from './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import 'lodash';
import Link from './components/Link/index.js';
import { D as Drawer } from './Drawer-NMc-EopI.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

/* eslint-disable jsx-a11y/anchor-is-valid */
const LanguageDrawer = ({ isOpen, onClose, hrefLinks = [], enableNA = false, enableAPAC = false, }) => {
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { useDispatch } = useContext(CoreContext);
    const [windowSize, setWindowSize] = useState({ width: undefined, height: undefined });
    const dispatch = useDispatch();
    const { locale, push, pathname, asPath } = useRouter();
    const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= XXXL_WIDTH;
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
    }, []);
    const handleClose = () => {
        dispatch(toggleModal(null));
    };
    const handleChangeLocation = (newLocale) => {
        const noRedirectCookie = getCookie(COOKIE_STOP_REDIRECT);
        const localeCookie = getCookie(COOKIE_LANGUAGE_NAME);
        let fullUrl = '';
        if (!noRedirectCookie && noRedirectCookie !== undefined) {
            setCookie(COOKIE_STOP_REDIRECT, '1');
        }
        if (!localeCookie || localeCookie !== newLocale) {
            setCookie(COOKIE_LANGUAGE_NAME, newLocale);
        }
        if (typeof window !== 'undefined') {
            fullUrl = `${window.location.origin}${asPath}`;
            setCookie(COOKIE_LANG_PREF, newLocale);
        }
        if (pathname === HOME) {
            push(HOME, null, { locale: newLocale });
        }
        else {
            push(fullUrl, null, { locale: newLocale });
        }
        handleClose();
    };
    const handleSiteChange = (url) => {
        push(url, null);
    };
    const ref = useAutoFocus({ tag: 'button' });
    const defaultLinks = { links: [] };
    const [naLinkObj = defaultLinks, apacLinkObj = defaultLinks] = hrefLinks;
    const { links: naLinks = [] } = 'links' in naLinkObj ? naLinkObj : defaultLinks;
    const { links: apacLinks = [] } = 'links' in apacLinkObj ? apacLinkObj : defaultLinks;
    const renderLinks = (links, title, icon) => links.length > 0 && (React.createElement("ul", { ref: ref, className: "languages-list" },
        React.createElement("li", null,
            React.createElement("h2", { className: "subtitle" }, tLabel(title))),
        links.map(item => {
            var _a;
            return (React.createElement("li", { key: item.value, className: "language-item" },
                React.createElement(Link, { className: classnames('drawer-option button-reset', (_a = item.icon) !== null && _a !== void 0 ? _a : icon, {
                        active: item.value === locale,
                    }), onClick: () => handleSiteChange(item.url), noUnderline: true }, item.value)));
        })));
    return (React.createElement(Drawer, { isSmall: isSmallScreen, open: isOpen, onClose: onClose, name: "language" },
        React.createElement("h1", { className: "title" }, tHeading('languageSelection')),
        React.createElement("ul", { ref: ref, className: "languages-list" },
            React.createElement("li", null,
                React.createElement("h2", { className: "subtitle" }, tLabel('europe'))),
            LANGUAGE_OPTIONS.map(item => (React.createElement("li", { key: item.label, className: "language-item" },
                React.createElement(Link, { className: classnames('drawer-option button-reset', item.value, {
                        active: item.value === locale,
                    }), onClick: () => handleChangeLocation(item.value), noUnderline: true }, item.label))))),
        enableAPAC && renderLinks(apacLinks, 'asiaPacific', 'cn'),
        enableNA && renderLinks(naLinks, 'northAmerica')));
};
var LanguageDrawer$1 = withProviders(LanguageDrawer, { translation: true });

export { LanguageDrawer$1 as L };
//# sourceMappingURL=LanguageDrawer-4iVY1BH9.js.map
